
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { pipe } from "fp-ts/function";
import * as t from "io-ts";
import { fold } from "fp-ts/Either";
import {
  ControlsTreeContext,
  textAndRichTextVariableItem,
  textAndRichTextVariableOptions
} from "@/types/controls";
import Popout from "@/components/UI/Popout.vue";
import Icon from "@/components/UI/Icon.vue";
import {
  filterItem,
  mapItem,
  fillEmptyLabelsWithValue
} from "@/lib/controls/populate";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: { IconButton, Dropdown, Popout, Icon }
})
export default class VariablesDropdown extends Vue {
  @Inject({ from: "context", default: null })
  readonly context!: ControlsTreeContext | null;

  @Prop()
  options!: textAndRichTextVariableOptions;

  @Prop({ default: () => [] })
  variables!: textAndRichTextVariableItem[];

  get populate() {
    return this.options?.populate || {};
  }

  get internalItems() {
    return [...this.populatedItems, ...this.variables];
  }

  get populatedItems() {
    if (!this.populate || !this.populate.path) {
      return [];
    }

    if (!this.context) {
      console.log(`[VARIABLES] Context is not available to populate dropdown.`);
      return [];
    }

    const controlValue = this.context.getControlValue(this.populate.path);

    return pipe(
      controlValue,
      t.array(t.unknown).decode,
      fold(
        () => {
          console.log(
            `[VARIABLES] Populate path '${this.populate?.path}' is invalid.`
          );

          return [];
        },
        unknownArray => {
          return unknownArray
            .map(item => fillEmptyLabelsWithValue(this.populate, item)) // if the text field is empty, populate it with the value
            .filter(item => filterItem(this.populate, item)) // Filter out items based on condition
            .map(item => mapItem(this.populate, item)) // Turn array into the `v-select` expected input
            .filter(Boolean); // Filter out falsy values
        }
      )
    );
  }

  insertVariable(value: string) {
    this.$emit("input", value);
  }
}
